import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getReplenishmentUser = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/list/`, {params});
};

export {
    getReplenishmentUser
}